<template>
  <div>
    <b-field label="Filters">
    </b-field>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <b-datetimepicker
            rounded
            placeholder="Start Date"
            icon="calendar-today"
            horizontal-time-picker
            v-model="startDate"
          >
          </b-datetimepicker>
        </div>
        <div class="level-item">
          <b-datetimepicker
            rounded
            placeholder="End Date"
            icon="calendar-today"
            horizontal-time-picker
            v-model="endDate"
          >
          </b-datetimepicker>
        </div>

        <p class="level-item">
          <b-select placeholder="Integration Type" v-model="integrationId"
            @change.native="getLogs">
            <option value="">All</option>
            <option
              v-for="type in integrationTypes"
              :value="type.id"
              :key="type.id"
            >{{ type.name }}</option>
          </b-select>
        </p>

        <p class="level-item">
          <b-field>
            <b-input placeholder="Lead Id" v-model="leadId"
              @keypress.native="handleKeyPress"></b-input>
          </b-field>
        </p>

        <p class="level-item">
          <b-field>
            <b-input placeholder="First Name" v-model="firstName"
              @keypress.native="handleKeyPress"></b-input>
          </b-field>
        </p>

        <p class="level-item">
          <b-field>
            <b-input placeholder="Last Name" v-model="lastName"
              @keypress.native="handleKeyPress"></b-input>
          </b-field>
        </p>

        <p class="level-item">
          <b-field>
            <b-input placeholder="Community Id" v-model="communityId"
              @keypress.native="handleKeyPress"></b-input>
          </b-field>
        </p>

        <p class="level-item">
          <button class="button field is-success" @click="getLogs">
            <span>Apply</span>
          </button>
        </p>
      </div>
    </nav>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <b-select v-model="perPage" @input="getLogs">
            <option value="5">5 per page</option>
            <option value="10">10 per page</option>
            <option value="20">20 per page</option>
            <option value="50">50 per page</option>
            <option value="100">100 per page</option>
          </b-select>
        </div>
        <div class="level-item">
          <button class="button field is-primary is-light">
            <span>Total: {{total}}</span>
          </button>
        </div>
      </div>
    </nav>
    <section>
      <b-pagination
        v-show="logs.length"
        :total="total"
        v-model="currentPage"
        :range-before="1"
        :range-after="1"
        :rounded="true"
        :per-page="perPage"
        @change="getLogs"
      >
      </b-pagination>
    </section>
    <section>
      <b-tabs v-model="activeTab">
        <b-tab-item label="Integration Logs">
          <b-table
            :data="logs"
            :columns="columns"
            :selected.sync="selected"
            :checked-rows.sync="checkedRows"
            :sticky-header="true"
            :height="1000"
            focusable
            striped
            hoverable
            checkable
            @click.native="onClick"
            @dblclick.native="onDblClick"
          >
          </b-table>
        </b-tab-item>
        <b-tab-item :disabled="checkedRows.length == 0" label="Selected">
          <button
            class="button field is-success"
            v-clipboard:copy="jsonString"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <span>COPY</span>
          </button>
          <button class="button field is-success" :disabled="checkedRows.length == 0">
            <download-csv :data="checkedRows">CSV</download-csv>
          </button>
          <div style="white-space: pre-wrap;">
            <pre id="export">{{ checkedRows }}</pre>
          </div>
        </b-tab-item>

        <!-- <b-tab-item label="Selected">
          <pre>{{ selected }}</pre>
        </b-tab-item> -->
      </b-tabs>
    </section>
  </div>
</template>


<script>
import { pickBy } from 'lodash';

export default {
  name: 'Integrations',
  computed: {
    integrationIndex() {
      return this.integrationTypes.reduce((index, type) => {
        // eslint-disable-next-line no-param-reassign
        index[type.id] = type.name;

        return index;
      }, {});
    },
    jsonString() {
      return JSON.stringify(this.checkedRows, null, 2);
    },
    query() {
      const start = this.perPage * (this.currentPage - 1);
      const limit = this.perPage;

      return {
        startDate: this.startDate.toISOString(),
        endDate: this.endDate.toISOString(),
        integrationId: this.integrationId,
        purchasedLeadId: this.leadId,
        firstName: this.firstName,
        lastName: this.lastName,
        communityId: this.communityId,
        start,
        limit,
      };
    },
  },
  data() {
    const logs = [];
    const startDate = new Date();
    const endDate = new Date();

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 59);

    return {
      integrationTypes: [],
      logs,
      total: 0,
      currentPage: 1,
      perPage: 100,
      startDate,
      endDate,
      selected: null,
      integrationFilter: '',
      firstName: '',
      lastName: '',
      leadId: '',
      integrationId: '',
      communityId: '',
      activeTab: 0,
      checkedRows: [],
      columns: [
        {
          field: 'logId',
          label: 'Log ID',
          width: '10',
          numeric: true,
        },
        {
          field: 'purchasedLeadId',
          label: 'Lead ID',
          width: '10',
          numeric: true,
        },
        {
          field: 'firstName',
          label: 'First Name',
          width: '100',
        },
        {
          field: 'lastName',
          label: 'Last Name',
          width: '100',
        },
        {
          field: 'communityId',
          label: 'Community Id',
          width: '100',
        },
        {
          field: 'date',
          label: 'Date',
          width: '40',
        },
        {
          field: 'integration',
          label: 'Integration',
          centered: true,
          width: '40',
        },
        {
          field: 'message',
          label: 'Message',
          centered: true,
          width: '300',
        },
        {
          field: 'status',
          label: 'Status',
          centered: true,
          width: '40',
        },
      ],
    };
  },
  watch: {
    startDate() {
      this.getLogs();
    },
    endDate() {
      this.getLogs();
    },
  },
  created() {
    this.getIntegrations();
    this.getLogs();
  },
  methods: {
    handleKeyPress(e) {
      if (e.key === 'Enter') {
        this.getLogs();
      }
    },
    async getLogs() {
      try {
        const res = await this.$api.get('/logs', { params: pickBy(this.query) });

        this.checkedRows = [];
        this.total = res.data.total;
        this.logs = res.data.logs.map((log) => {
          const {
            // eslint-disable-next-line
            _id: logId,
            PurchasedLead,
            communityId,
            message,
            status,
            integrationId,
            createdAt,
            request,
            response,
          } = log;

          return {
            logId,
            // eslint-disable-next-line
            purchasedLeadId: PurchasedLead._id,
            firstName: PurchasedLead.firstName,
            lastName: PurchasedLead.lastName,
            communityId,
            message,
            status,
            integration: this.integrationIndex[integrationId],
            date: createdAt,
            request,
            response,
          };
        });
      } catch (error) {
        this.$buefy.dialog.alert({
          title: 'Api Error GET /logs',
          message: error.message,
          type: 'is-danger',
        });
      }
    },

    async getIntegrations() {
      try {
        const res = await this.$api.get('/integrations');
        const types = res.data.map(({ _id, serviceTitle }) => ({ id: _id, name: serviceTitle }));

        this.integrationTypes = types;
      } catch (error) {
        this.$buefy.dialog.alert({
          title: 'Api Error GET /integrations',
          message: error.message,
          type: 'is-danger',
        });
      }
    },
    onCopy() {
      this.$buefy.dialog.alert('Copied!');
    },
    onError() {
      this.$buefy.dialog.alert({
        title: 'Copy Error',
        message: 'Could not copy to clipboard.',
        type: 'is-danger',
      });
    },
    onClick() {
      const pos = this.checkedRows.indexOf(this.selected);
      if (pos >= 0) {
        this.checkedRows.splice(pos, 1);
      } else {
        this.checkedRows.push(this.selected);
      }
    },
    onDblClick() {
      this.checkedRows.splice(0, this.checkedRows.length, this.selected);
      this.activeTab = 1;
    },
  },
};
</script>

<style scoped>
.filters {
  margin: 10px 10px 10px 10px;
}

.export {
  padding: 10px 10px 10px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Integrations.vue